import { render, staticRenderFns } from "./BoardBox.vue?vue&type=template&id=0f987a10&scoped=true"
import script from "./BoardBox.vue?vue&type=script&lang=js"
export * from "./BoardBox.vue?vue&type=script&lang=js"
import style0 from "./BoardBox.vue?vue&type=style&index=0&id=0f987a10&prod&lang=scss&scoped=true"
import style1 from "./BoardBox.vue?vue&type=style&index=1&id=0f987a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f987a10",
  null
  
)

export default component.exports